// extracted by mini-css-extract-plugin
export var categoryTag = "PartnersSection-module--categoryTag--80411";
export var categoryTags = "PartnersSection-module--categoryTags--7276c";
export var clearFiltersButton = "PartnersSection-module--clearFiltersButton--8e441";
export var logo = "PartnersSection-module--logo--fd548";
export var logoWrapper = "PartnersSection-module--logoWrapper--ed0b8";
export var noResults = "PartnersSection-module--noResults--0630d";
export var partnerCard = "PartnersSection-module--partnerCard--d3d36";
export var partnerDesc = "PartnersSection-module--partnerDesc--1c321";
export var partnerGrid = "PartnersSection-module--partnerGrid--1a9ee";
export var partnerInfo = "PartnersSection-module--partnerInfo--e2843";
export var partnerLink = "PartnersSection-module--partnerLink--b2abf";
export var partnerName = "PartnersSection-module--partnerName--c5433";
export var partnersSection = "PartnersSection-module--partnersSection--18640";